import FirebaseApp from "./context";
import "firebase/storage";
const date = new Date().toISOString();
const uploadImageToFirebase = async (file) => {
  const storageRef = FirebaseApp.storage().ref();
  const imageRef = storageRef.child(`test/${date}${file.name}`);
  return imageRef.put(file).then(() => {
    return imageRef;
  });
};

export default uploadImageToFirebase;
